import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CADERChargesAdmin from '../../components/admin/CADERChargesAdmin';

const DerChargesPage = () => {
  return (
    <AdminLayout title="CA DER Charges" requireSuperAdmin>
      <CADERChargesAdmin />
    </AdminLayout>
  );
};

export default DerChargesPage;
